import React, { useRef, useCallback } from 'react';

interface VideoPlayerProps {
  src: string;
  defaultVolume?: number;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ src, defaultVolume }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleMetadata = useCallback(() => {
    if (videoRef.current && defaultVolume !== undefined)
      videoRef.current.volume = defaultVolume;
  }, [defaultVolume]);

  return (
    <div className="mb-[40px] rounded-[12px] overflow-hidden border border-surface-hover shadow-[0_2px_12px_rgba(34,211,238,0.08)]">
      <video
        ref={videoRef}
        src={src}
        controls
        playsInline
        onLoadedMetadata={handleMetadata}
        className="w-full block"
      />
    </div>
  );
};

export default VideoPlayer;
